import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import SingleSelect from '@/components/common/form/SingleSelect';
import type FilterFields from '@/constants/ConstituentSearchFilterField';
import type CustomFieldTypes from '@/constants/customFields/CustomFieldTypes';
import OperatorLabelMap from '@/constants/forms/OperatorLabelMap';
import translate from '@/lib/intl/translate';
import FieldOperatorsMap from '../constants/FieldOperatorsMap';

type AdvancedFilterOperatorSelectProps = {
  uid: string;
  field: FilterFields | CustomFieldTypes;
  fieldArrayPrefix: string;
};

export default function AdvancedFilterOperatorSelect({
  field,
  uid,
  fieldArrayPrefix = '',
}: AdvancedFilterOperatorSelectProps) {
  const { control } = useFormContext();
  const name = `${fieldArrayPrefix}operator`;

  const operators = React.useMemo(
    () => FieldOperatorsMap[field] || [],
    [field],
  );

  return (
    <Controller
      control={control}
      defaultValue=""
      name={name}
      render={({ field: { onChange, value } }) => (
        <SingleSelect
          classes={{ select: 'w-full' }}
          id={`filter-operator-select-${uid}`}
          label={translate('FILTERS_OPERATOR_LABEL')}
          name={name}
          onChange={onChange}
          required
          value={value}
        >
          {operators.map((operator) => (
            <SingleSelect.Item key={operator} value={operator}>
              {translate(OperatorLabelMap[operator])}
            </SingleSelect.Item>
          ))}
        </SingleSelect>
      )}
    />
  );
}
